
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"22","viewBox":"0 0 96 96","width":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#6A6E83","d":"M48 20c21.15 0 34.502 19.998 38.998 28C82.494 56.016 69.145 76 48 76 26.853 76 13.503 56.118 9.003 48.149 13.5 40.101 26.853 20 48 20m0-8C16 12 0 48.166 0 48.166S16 84 48 84s48-36 48-36-16-36-48-36z"}}),_c('path',{attrs:{"fill":"#6A6E83","d":"M48 40c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8m0-8c-8.836 0-16 7.164-16 16 0 8.837 7.164 16 16 16 8.837 0 16-7.163 16-16 0-8.836-7.163-16-16-16z"}})])
          )
        }
      }
    